import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalState } from './global.reducer';

export const selectGlobalState = createFeatureSelector<GlobalState>('global');

export const selectCountryCode = createSelector(
   selectGlobalState,
   (state) => state.countryCode
);

export const selectShowAdditionalOffers = createSelector(
   selectCountryCode,
   (countryCode) => {
      const excludedCountries = ['US'];
      return !excludedCountries.includes(countryCode?.toUpperCase());
   }
);
